// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import styled, { css } from "styled-components";

// Define the styled components
export const ParentContainer = styled.div`
  width: 100%;
  height: auto;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.VividAuburn};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: ${MARGIN.fix140};
  padding-bottom: ${MARGIN.fix140};
  position: relative;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: ${MARGIN.max80} ${MARGIN.max24};
    height: auto;
  }
`;

export const Title = styled.div`
  width: 369px;
  text-align: center;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 326px;
  }
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: ${MARGIN.max12};
  margin-top: ${MARGIN.max80};
  height: fit-content;
  width: 1464px;
  @media (max-width: 1500px) {
    /* height: 572px; */
    height: fit-content;
    width: 1104px;
    margin-top: ${MARGIN.max40};
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    grid-template-rows: minmax(300px, auto) repeat(4, 1fr);
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    height: auto;
    margin-top: ${MARGIN.max40};
    gap: ${MARGIN.max8};
  }
`;

export const SectionIllustration = styled.img`
  position: absolute;
  top: -168px;
  right: -168px;
  width: 400px;
  height: 400px;
`;

export const SectionSecondIllustration = styled.img`
  position: absolute;
  left: -173px;
  top: 330px;
  width: 398.75px;
  height: 398.75px;
`;
